import { useFragment } from '@apollo/client';
import { UserIcon } from '@synoptic/ui-kit/icons/react/user.js';
import { Fragment } from 'react/jsx-runtime';
import { TournamentState } from '@/__generated__/graphql';
import { TournamentStatusFragment } from './tournament-status-fragment';
import { getStateStat, getTournamentStateGroup } from './utils';
import {
  statItem,
  statStateGroup,
  statsContainer,
  statSeparator,
} from './tournament-status.css';

export const TournamentStatus = ({
  tournamentId,
}: {
  tournamentId: string;
}) => {
  const {
    data: { deadline, participantsCount, state },
  } = useFragment({
    fragment: TournamentStatusFragment,
    from: { __typename: 'Tournament', id: tournamentId },
  });

  const stateGroup = getTournamentStateGroup(state);

  const stats = [];

  if (stateGroup) {
    stats.push(
      <div key="state-group" className={statStateGroup[stateGroup]}>
        {stateGroup}
      </div>,
    );
  }

  if (state) {
    const stat = getStateStat(state, deadline);
    if (stat) {
      stats.push(
        <div key="state" className={statItem}>
          {stat.icon}
          {stat.label}
        </div>,
      );
    }
  }

  if (state !== TournamentState.Draft) {
    stats.push(
      <div key="participants-count" className={statItem}>
        <UserIcon />
        {participantsCount}
      </div>,
    );
  }

  return (
    <div className={statsContainer}>
      {stats.map((stat, idx) => (
        <Fragment key={stat.key}>
          {idx > 0 ? <span className={statSeparator}>•</span> : null}
          {stat}
        </Fragment>
      ))}
    </div>
  );
};
